'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002425 from "./presto.-Login-Page-View$$anon$25.js";
import * as $j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse$0024 from "./presto.types$proto$-Generic-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$24() {
  this.b7z = null;
  this.b7r = null;
  this.b7s = false;
  this.b7A = null;
  this.b7B = false;
  this.b7E = null;
  this.b7x = null;
  this.b7y = false;
  this.b7t = null;
  this.b7u = false;
  this.b7v = null;
  this.b7w = false;
  this.b7C = false;
  this.b7D = false;
  this.b7z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b7E = "GenericResponse";
}
export { $c_Lpresto_LoginPageView$$anon$24 as $c_Lpresto_LoginPageView$$anon$24 };
$p = $c_Lpresto_LoginPageView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$24;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$24() {
}
export { $h_Lpresto_LoginPageView$$anon$24 as $h_Lpresto_LoginPageView$$anon$24 };
$h_Lpresto_LoginPageView$$anon$24.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b7z;
});
$p.M = (function() {
  if ((!this.b7s)) {
    this.b7r = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b7s = true;
  }
  return this.b7r;
});
$p.O = (function() {
  if ((!this.b7B)) {
    this.b7A = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b7B = true;
  }
  return this.b7A;
});
$p.D = (function() {
  return this.b7E;
});
$p.t = (function() {
  if ((!this.b7y)) {
    this.b7x = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("error", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b7y = true;
  }
  return this.b7x;
});
$p.N = (function() {
  if ((!this.b7u)) {
    this.b7t = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b7u = true;
  }
  return this.b7t;
});
$p.Q = (function() {
  if ((!this.b7w)) {
    this.b7v = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002425.$c_Lpresto_LoginPageView$$anon$25();
    this.b7w = true;
  }
  return this.b7v;
});
$p.v = (function() {
  if ((!this.b7D)) {
    this.b7C = false;
    this.b7D = true;
  }
  return this.b7C;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee156) => ((p) => \u03b4scrutinee156.cHO(p)))($j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse$0024.$m_Lpresto_types$proto$GenericResponse$())));
});
var $d_Lpresto_LoginPageView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$24, "presto.LoginPageView$$anon$24", ({
  Mo: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$24 as $d_Lpresto_LoginPageView$$anon$24 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$24.js.map
